import { nameofAccountSchemaDOB, nameofAccountSchemaEmail, nameofAccountSchemaFirstName, nameofAccountSchemaLastName, nameofAccountSchemaMiddleName, nameofAccountSchemaPhoneNumber } from "../../firestore/Types/AccountSchema";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { Textbox } from "../Common/Textbox";
import { ProfileImage } from "../Common/ProfileImage";
import { getProfilePictureURL, uploadProfilePicture } from "../../firebase/storage/ProfileFunctions";
import { CropProfile } from "../ImageCropper/CropProfile";
import { MIN_DIMENSION } from "../ImageCropper/ImageCropper";
import { DateBox } from "../Common/DateBox";

export function UserDetails() {
    const { account, currentUser } = useAuth();
    const [fileName, setFileName] = useState("");
    const [error, setError] = useState("");
    const [newFileName, setNewFileName] = useState("");
    const [showCropProfile, setShowCropProfile] = useState(false);

    const profileRef = useRef<HTMLInputElement>(null);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;

            imageElement.addEventListener("load", (e: Event) => {
                if (error) setError("");
                const { naturalWidth, naturalHeight } = e.currentTarget as HTMLImageElement;
                if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                    setError("Image must be at least 150 x 150 pixels.");
                    return setNewFileName("");
                }
            });
            setNewFileName(imageUrl);
        });
        reader.readAsDataURL(file);
        if (e.target.files && e.target.files.length > 0) {
            setNewFileName(e.target.files[0].name);
            setShowCropProfile(true);
        }
    };

    const handleCancleFileCrop = () => {
        setNewFileName("");
        setShowCropProfile(false);
        profileRef.current!.src = "";
    };

    const handleRefreshProfile = useCallback( async () => {
        await getProfilePictureURL(currentUser.uid).then((url) => {
            if (url) {
                setFileName(url);
            }
        });
    }, [currentUser]);

    const handleUploadImage = async (file: File) => {
        await uploadProfilePicture(currentUser.uid, file);
        await getProfilePictureURL(currentUser.uid).then((url) => {
            if (url) {
                setFileName(url);
            }
        });
    }

    useEffect(() => {
        getProfilePictureURL(currentUser.uid).then((url) => {
            if (url) {
                setFileName(url);
            }
        });
    }, [currentUser]);

    return (
        <div className="section-box p-4">
            <div className="flex flex-row">
                <h3 className="section-title">Personal Details</h3>
            </div>
            <div className="items-center whitespace-nowrap flex flex-row">
                <ProfileImage profilePicture={fileName} />
                
                <div className="overflow-hidden">
                    <h3 className="mb-1 text-lg font-bold text-gray-900">Profile picture</h3>
                    <div className="mb-4 text-sm text-gray-500 dark:text-gray-400">
                        JPG, GIF or PNG. Max size of 800K
                    </div>
                    <div className="flex items-center space-x-4">
                        <input
                            type="file"
                            accept="image/*"
                            multiple={false}
                            ref={profileRef}
                            onChange={handleFileChange}
                            hidden
                        />
                        <button className="primary-button" onClick={() => profileRef.current && profileRef.current.click()}>
                            Upload picture
                        </button>
                        <button type="button" className="delete-button">
                            Delete
                        </button>
                    </div>
                    {showCropProfile ? <CropProfile closeModal={handleCancleFileCrop} imgSrc={newFileName} refresh={handleRefreshProfile} uploadImage={handleUploadImage}/> : <></>}
                </div>
            </div>
          
            <Textbox label={"First Name"} name={nameofAccountSchemaFirstName} placeholder={account.FirstName} defaultValue={account.FirstName} isReadonly={true}></Textbox>
            <Textbox label={"Middle Name"} name={nameofAccountSchemaMiddleName} placeholder={account.MiddleName ?? ""} defaultValue={account.MiddleName ?? ""} isReadonly={true}></Textbox>
            <Textbox label={"Last Name"} name={nameofAccountSchemaLastName} placeholder={account.LastName} defaultValue={account.LastName} isReadonly={true}></Textbox>
            <Textbox label={"Email"} name={nameofAccountSchemaEmail} placeholder={account.Email} defaultValue={account.Email} isReadonly={true}></Textbox>
            <Textbox label={"Phone"} name={nameofAccountSchemaPhoneNumber} placeholder={account.PhoneNumber} defaultValue={account.PhoneNumber} isReadonly={true}></Textbox>
            <DateBox label={"DOB"} name={nameofAccountSchemaDOB} placeholder={account.DOB} defaultValue={account.DOB} isReadonly={true}></DateBox>
        </div>
    );
}
